import Vue from "vue";
import LoadingPage from "./LoadingPage.vue";
import link from "./link.vue";

Vue.component("LoadingPage", LoadingPage);
Vue.component("c-link", link);
